import { environment as local } from '../environments/environment.local';
import { environment as localStaging } from '../environments/environment.local-staging';
import { environment as production } from '../environments/environment.prod';
import { environment as rc } from '../environments/environment.rc';
import { environment as staging } from '../environments/environment.staging';

export const environments = {
  rc,
  staging,
  local,
  'local-staging': localStaging,
  production,
};
